import { eventMap } from '../constants/tagular';
import {
  readHostEventTransportResult,
  type HostEventTransportResult,
} from './hostEventTransport';

/**
 * Sends an event to tagular when window.tagular is available.
 * Uses eventMap from constants/tagular for @type. Try/catch with console.warn on error.
 *
 * The host beam may return `sent`, `queued`, or `rejected`. A missing
 * beam is `rejected`. A beam that returns nothing else counts as `sent`.
 */
const tagularEvent = (
  eventName: string,
  eventData: Record<string, unknown>,
): HostEventTransportResult => {
  if (
    typeof window === 'undefined' ||
    !('tagular' in window) ||
    typeof window.tagular !== 'function'
  ) {
    return 'rejected';
  }
  try {
    const eventType = eventMap[eventName];
    const payload: Record<string, unknown> = {
      ...(eventType !== undefined ? { '@type': eventType } : {}),
      ...eventData,
    };
    const tagularBeam = window.tagular as (
      channel: string,
      eventName: string,
      payload: Record<string, unknown>,
    ) => unknown;
    return readHostEventTransportResult(
      tagularBeam('beam', eventName, payload),
    );
  } catch {
    console.warn('[tagularEvent] dispatch-failed:', eventName);
    return 'rejected';
  }
};

export default tagularEvent;
